module.exports = __webpack_public_path__ + "static/media/Edison_Traditinoal_at_Ivory_Ridge_3.43bec9b8.jpg";